import React from 'react';
import { useDispatch } from 'react-redux';
import CenterPanel from './centerPanel';
import RightPanel from './rightPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { updateOrgUnitSearch, updateRHSTotalCount } from 'actions/organisation';

export default function ContentCreateWA(props) {
  const dispatch = useDispatch();

  const searchInEntityPageByName = (name, cb) => {
    // Set filter to be 2 == Waiting area
    // When a new WA is created, it will navigate back to Entity Admin page;
    // Filter will be reset to waiting area and search by the new WA name
    dispatch(updateOrgUnitSearch(name));
    props.changeFilterValue(2);
    dispatch(updateRHSTotalCount('wa', 1));
    if (cb) cb();
  };

  return (
    <Modal show={props.showCreateWaitingAreaModal} hideWhenClickAway={false}>
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.WaitingArea.WaitingAreaCreate}
        title={APP.LANGUAGE.CreateWaitingArea.Title}
        subtitle={props.organisation ? props.organisation.name + ' (' + props.organisation.abbreviatedName + ')' : ''}
      />

      <div className="content">
        <div className="main-ui-container ">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel
                  showCreateWaitingAreaModal={props.showCreateWaitingAreaModal}
                  createWAForm={props.createWAForm}
                  organisation={props.organisation}
                  searchInEntityPageByName={searchInEntityPageByName}
                />
              </div>
            </div>
            <CenterPanel
              showCreateWaitingAreaModal={props.showCreateWaitingAreaModal}
              createWAForm={props.createWAForm}
              organisation={props.organisation}
              dispatch={props.dispatch}
            />
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <RightPanel
                showCreateWaitingAreaModal={props.showCreateWaitingAreaModal}
                createWAForm={props.createWAForm}
                organisation={props.organisation}
                searchInEntityPageByName={searchInEntityPageByName}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
